module.exports = __webpack_public_path__ + "img/stockRetireQuantite.ce593796.png";